import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { CREATE_TAG_MUTATION } from 'graphql/queries'
import {
  Container,
  Header,
  Button,
  Input,
  Segment,
  Grid,
} from 'semantic-ui-react'

export default class TagsNew extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      visible: true,
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  renderSubmit = event => {
    const variables = { input: { ...this.state } }
    return (
      <Mutation mutation={CREATE_TAG_MUTATION} variables={variables}>
        {(createTag, { data, loading }) => {
          if (loading) {
            return <Button loading>Saving...</Button>
          }

          return (
            <Button
              onClick={async () => {
                await createTag({ variables })
                this.props.history.push('/tags')
              }}
            >
              Save
            </Button>
          )
        }}
      </Mutation>
    )
  }

  render() {
    const { name } = this.state
    return (
      <Container>
        <Header as="h1">New Tag</Header>
        <div style={{ textAlign: 'right' }}>
          <Button color="red" onClick={() => this.props.history.push('/tags')}>
            Cancel
          </Button>
        </div>
        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column />
            <Grid.Column>
              <Segment>
                <Grid.Row>
                  <div style={{ marginRight: 12, marginBottom: 8 }}>
                    <label htmlFor="name">Name</label>
                  </div>
                  <Input
                    name="name"
                    onChange={this.handleChange}
                    value={name}
                  />
                </Grid.Row>
                {this.renderSubmit()}
              </Segment>
            </Grid.Column>
            <Grid.Column />
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}
